
export class AbstractProvider {

  userId;

  constructor(userId) {
    this.userId = userId;
  }

  async get(key, defaultValue) { return defaultValue; }

  getSync(key, defaultValue) { return defaultValue; }

  async patch() { return true; }

  async patchObject() { return null; }

  /**
   * @param {string}key
   * @param {any}value
   * @return {object}
   */
  toKeyValuePair(key, value) {
    return { [key]: value };
  }
}
